"use strict";
exports.__esModule = true;
exports.AlertStatus = void 0;
var AlertStatus;
(function (AlertStatus) {
    AlertStatus["Open"] = "open";
    AlertStatus["InProcess"] = "inProcess";
    AlertStatus["Blocked"] = "blocked";
    AlertStatus["Waiting"] = "waiting";
    AlertStatus["OutreachNeeded"] = "outreachNeeded";
    AlertStatus["Closed"] = "closed";
})(AlertStatus = exports.AlertStatus || (exports.AlertStatus = {}));
